module.exports = __webpack_public_path__ + "img/Genk.7b26d60a.png";